export default "__VITE_ASSET__CQDw4L$R__"